import { render, staticRenderFns } from "./RightBlock.vue?vue&type=template&id=b7832700&scoped=true"
import script from "./RightBlock.vue?vue&type=script&lang=js"
export * from "./RightBlock.vue?vue&type=script&lang=js"
import style0 from "./RightBlock.vue?vue&type=style&index=0&id=b7832700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7832700",
  null
  
)

export default component.exports